import React, { useEffect, useState, useRef } from 'react'
import {Transition, SwitchTransition, CSSTransition} from 'react-transition-group'
import "../Styles/Repair.css"
import Color from '../Components/Colors/Color'

const Repair = () => {

    const [step, setStep] = useState(1);
    const timerRef = useRef(null);

    const resetTimer = () => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
        timerRef.current = setInterval(() => {
          setStep(prevStep => (prevStep % 3) + 1);
        }, 7000);
      };

    
    useEffect(() => {
        resetTimer();

        return () => clearInterval(timerRef.current);
      }, []);

   

    

    const Step1 = () => {
        return(
            <div className='repair-step-content'>
                <h4 className='repair-step-header'>
                    We communicate and coordinate the planning decision
                </h4>
                <p className='repair-step-text'>
                    We meet and you share your wishes and ideas
                </p>    
            </div> 
        )
    }

    const Step2 = () => {
        return(
                <div className='repair-step-content'>
                    <h4 className='repair-step-header'>
                        We make estimates, we conclude a contract and begin repairs
                    </h4>
                    <p className='repair-step-text'>
                        We provide you with performance terms
                    </p>           
                </div> 
        )
    }

    const Step3 = () => {
        return(
                <div className='repair-step-content'>
                    <h4 className='repair-step-header'>
                        Finish the job and hand over the object
                    </h4>
                    <p className='repair-step-text'>
                        You estimate and share your feedback
                    </p>      
                </div> 
        )
    }


    const Step = () => {
        switch(step){
            case 1 : {
                return <Step1 />;
            }
            case 2 : {
                return <Step2 />;
            }
            case 3 : {
                return <Step3 />;
            }
            default: {
                return <Step1 />;
            }
        }
    }

    const steps = [
        <Step1 key={1} />,
        <Step2 key={2} />,
        <Step3 key={3} />,
    ];

    const handleStepChange = (stage) => {
        setStep(stage);
        resetTimer();
    }

    


    return(
        <div className='repair-container' style={{color: Color.secondaryText}}>
            <h1 className='repair-header'>
                Repair Process
            </h1>
            <div className='repair-stepper-container'>
                <div className='repair-step-1-container'>
                    <img src='/Images/step-1.png' alt='1st step' className={`repair-step-img step-1 ${step == 1 ? '' : 'active'}`} onClick={() => handleStepChange(1)} />
                    <img src='/Images/step-1-active.png' alt='1st step' className={`repair-step-img step-1 ${step == 1 ? 'active' : ''}`} onClick={() => handleStepChange(1)} />
                    
                </div>

                <div className='repair-step-arrow-container'>
                    {/* <img src='/SVGs/step_arrow-1.svg' alt='curve-arrow' className='repair-step-arrow-1' onClick={() => handleStepChange(2)}/> */}
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(-45)matrix(1, 0, 0, -1, 0, 0)" className={`repair-step-arrow-1 ${step > 1 ? 'active' : ''}`} onClick={() => handleStepChange(2)}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 4.5L17 9.5M12 4.5L7 9.5M12 4.5L12 11M12 14.5C12 16.1667 11 19.5 7 19.5" stroke="#fff" strokeWidth="0.36" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                </div>

                <div className='repair-step-2-container'>

                    <img src='/Images/step-2.png' alt='2nd step' className={`repair-step-img step-2 ${step == 2 ? '' : 'active'}`}onClick={() => handleStepChange(2)} />
                    <img src='/Images/step-2-active.png' alt='2nd step' className={`repair-step-img step-2 ${step == 2 ? 'active' : ''}`} onClick={() => handleStepChange(2)} />
                      
                    
                </div>

                <div className='repair-step-arrow-container'>
                    {/* <img src='/SVGs/step_arrow-2.svg' alt='curve-arrow' className='repair-step-arrow-2' onClick={() => handleStepChange(3)}/> */}
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(45)matrix(1, 0, 0, 1, 0, 0)" className={`repair-step-arrow-2 ${step > 2 ? 'active' : ''}`} onClick={() => handleStepChange(3)}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 4.5L17 9.5M12 4.5L7 9.5M12 4.5L12 11M12 14.5C12 16.1667 11 19.5 7 19.5" stroke="#fff" strokeWidth="0.36" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                </div>

                <div className='repair-step-3-container'>

                    <img src='/Images/step-3.png' alt='3rd step' className={`repair-step-img step-3 ${step == 3 ? '' : 'active'}`}onClick={() => handleStepChange(3)} />
                    <img src='/Images/step-3-active.png' alt='3rd step' className={`repair-step-img step-3 ${step == 3 ? 'active' : ''}`} onClick={() => handleStepChange(3)} />
                
                </div>
            </div>

            <div className='repair-content-container'>
                <div className="repair-step-container">
                    {/* <SwitchTransition>
                        <CSSTransition
                            key={step}
                            addEndListener={(node, done) => node.addEventListener('transitionend', done, false)}
                            classNames="fade"
                        > */}
                            
                            {steps[step - 1]}
                            
                        {/* </CSSTransition>
                    </SwitchTransition> */}
                </div>
            </div>
        </div>
    )
}

export default Repair